import React, { useState, useEffect } from 'react';
// Component moved from root console directory to system-management subdirectory
const ClusterConfig: React.FC = () => {
  return <div>Cluster Config - Component moved to system-management directory</div>;
};

export default ClusterConfig;
